var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.85,
    x: 0.294373,
    y: 0.177246,
    width: 33.827,
    height: 33.827,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_205_412",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_205_412",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAADwUlEQVR4nO2dO2sVQRiGJ1gmCoqFMY0iGImxjJcIijbiBaysxCJGJWqlv0IDiQqCl9J/oEiKeIEI+ge8xGijoBZqkRtGUXlkyAopzmyy58zuzDf7PXAgEOY77zvvntnZ2T1zjFEURVEURVEURVEURVEUDwAHgLvAJDBPQpiYAbYAT0gYEytAP/CdxDExAmwCvlIDTIwAj6kJJjaAg9QIExvZbKcRC8AlYIMRCIICeOvQeskIBkEBzDm0ijzyJQYgQ2iqvsQITdWXGKGp+hIjNFVfYoSm6kuM0FR9VSEU6AIuAGNLlrjns7/Hsv91eX5PDQBYD9wAfrM8f4F7QKcG4OETABwBZijONHBYPwGtdf4Q8IfmsW2HWtTQEBMbvoUCh1rs/KVD0rFYfJWGT6FAZ5PDTt5w1NSaVF0DuJ3TmT+AEaAPaM9eO4HRbOnbxa3QvkrFl1AWp5qu2c4HoCenbS/w0dHW1twYypekAC7mHPk9K2jfm/NJOB/Kl6QAxhylRgrUuOao8TCUL0kBTDlK9RWoYc8JjZgM5UtSAHOOUu0FanQ4asyG8iUpgBlHqY4CNdY4akyH8iUpgNcehqBdjhqvQvmSFMADR6nRAjWuO2rcD+VLUgCDjlJ2arl9Be135ExDT4fyJSmAdcAvRzl7kdW7TOe7LsR+AmtD+Sodn0KBYVe97Oi+lo3zHdlrdzbs2E52cTW0L0kBrAY+4w9ba3VoX6XiWyiLi20+vlVjlzD6Y/FVGmUIBQY8BDAQm69S8C0U2O9pGLI19sXiqzR8CgWOL7O2XxQ7qzoR2lep+BIKHPV0K7LR/YDCN+lrFQCwLWcx7j/jwBmge8kdMdvuLPBombazwNaqfVVCq0KBVcCLnM6bWslYnp073uXUeW7fqypfkgI4ldNpE0WuYrOr6Wc59U5W5asyWhEKtOXciJlqcgnBhvDeUdM+ythWti9JAex1tbfbHbSgyQ5HLnaV7UtSAMOO5uMlfnf5Stm+JAUw4Wg+6EHXOUftp2X7khTAF0fzbg+67BS1EZ/K9iUpgIVW7wM3cYN+oWxflSJGaKq+xAhN1ZcYoan6EiM0VV9ihKbqS4zQVH25hAI3gZe6a2K4AJLExAY1w8QGNcPEBjXDxAY1w8RGjlbdNTFwALprYuAAdNfEKsieudEAIty49bIRDIJOwndyTsKXfW2gVDWSArC/llEbTIxkz23WAhMj+gMOEQDsAb6ROCZmgM2pD0dGAtmzmXb3qzcreO5fFKH7VlEURVEURVEURVEURTHi+Afnn07SA2rBPAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.28041a73f16b12e0235e1b4f42806015.svg";
export { ForwardRef as ReactComponent };